import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';
import { CfAsset } from '../asset';
import { mapCfEntityToCfUspCard } from './mapper';

export class CfUspCard {
    static contentType = contentTypes.CfUspCard;

    static mapCfEntity = mapCfEntityToCfUspCard;

    constructor(data) {
        this.description = data.description;
        this.name = data.name;
        this.title = data.title;
        this.icon = data.icon && new CfAsset(data.icon);
    }
}
